import React from 'react';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '$0';
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const GoldInvestmentSummary = ({ investorResult }) => {
  if (!investorResult) {
    return <div className="text-center text-gray-500">No data available for Gold Investment.</div>;
  }

  return (
    <div className="bg-white shadow-md rounded-lg p-6 space-y-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-center text-yellow-600 mb-6">Gold Investment Summary</h2>

      <div className="bg-gray-50 rounded-lg p-6 space-y-4">
        <h3 className="text-center text-xl font-semibold mb-4 text-amber-700">Investor</h3>
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div>Initial Investment:</div>
          <div className="font-semibold">{formatCurrency(investorResult.totalInvestment)}</div>

          <div>Final Gold Value:</div>
          <div className="font-semibold">{formatCurrency(investorResult.finalValue)}</div>

          <div>Total Gold Accumulated:</div>
          <div className="font-semibold">{(investorResult.totalGoldAccumulated)} g</div>

          <div>Gold Price at the End of Terms:</div>
          <div className="font-semibold">{formatCurrency(investorResult.goldPriceAtEnd)} / g</div>

          <div>Appreciation:</div>
          <div className="font-semibold">{formatCurrency(investorResult.assetAppreciation)}</div>

          <div>Total ROI:</div>
          <div className="font-semibold">{investorResult.totalROI}%</div>

          <div>Annualized ROI:</div>
          <div className="font-semibold">{investorResult.annualizedROI}%</div>

          <div>IRR Estimate:</div>
          <div className="font-semibold">{investorResult.irrEstimate}%</div>
        </div>

        <p className="text-xs text-gray-400 text-center mt-4">
          * Based on compounded gold growth over {investorResult.termYears} years without withdrawal.
        </p>
      </div>
    </div>
  );
};

export default GoldInvestmentSummary;
